
const setClientList = (state, clientList) => {
  state.clientList = clientList;
};

const setClientSelected = (state, clientSelected) => {
  state.clientSelected = clientSelected;
};

export default {
  setClientList,
  setClientSelected,
};



// WEBPACK FOOTER //
// ./src/store/modules/client/mutations.js